import { render, staticRenderFns } from "./LikeHeart.vue?vue&type=template&id=387a6173"
import script from "./LikeHeart.vue?vue&type=script&lang=js"
export * from "./LikeHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports